import { t } from "@/translations"

// Optimized button state calculation
export const calculateButtonState = (availableSizesContext: any[], langCode: string) => {
    // If no sizes at all, default to out of stock
    if (availableSizesContext.length === 0) {
        return {
            label: t(langCode, "product_page.notify_me"),
            action: "notify-me",
            disabled: false,
            canAddToCart: false,
            isAnySizeSelected: false,
            selectedSize: {},
            item: ""
        }
    }

    const canAddToCart = availableSizesContext.some(
        size => size.isSelected && size.isAvailable
    )
    const isAnySizeSelected = availableSizesContext.some(size => size.isSelected)
    const isNoSizeAvailable = availableSizesContext.every(size => !size.isAvailable)
    const selectedSize =
        availableSizesContext.find(size => size.isSelected) ||
        availableSizesContext[0] ||
        {}
    const item = selectedSize?.item || ""

    // Determine button state and label
    let buttonState: {
        label: string
        action: "add-to-cart" | "notify-me" | "out-of-stock"
        disabled: boolean
    }
    if (isNoSizeAvailable) {
        // All sizes are out of stock - show notify me
        buttonState = {
            label: t(langCode, "product_page.notify_me"),
            action: "notify-me",
            disabled: false
        }
    } else if (isAnySizeSelected && !canAddToCart) {
        // A size is selected but that specific size is not available
        buttonState = {
            label: t(langCode, "product_page.notify_me"),
            action: "notify-me",
            disabled: false
        }
    } else {
        // Default case: Button always shows "Add to Cart"
        // (whether no size is selected OR size is selected and available)
        buttonState = {
            label: t(langCode, "product_page.add_to_cart"),
            action: "add-to-cart",
            disabled: false
        }
    }

    return {
        ...buttonState,
        canAddToCart,
        isAnySizeSelected,
        selectedSize,
        item
    }
}
